module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"high":"Full","low":"Empty","medium":"Medium"},"de":{"high":"Voll","low":"Leer","medium":"Mittel"},"fr":{"high":"Plein","low":"Vide","medium":"Moyen"},"it":{"high":"Completo","low":"Vuoto","medium":"Mezzo"}}')
  delete Component.options._Ctor
}
